import { render, staticRenderFns } from "./CustomModalTailwind.vue?vue&type=template&id=c5e2cef2&scoped=true"
import script from "./CustomModalTailwind.vue?vue&type=script&lang=js"
export * from "./CustomModalTailwind.vue?vue&type=script&lang=js"
import style0 from "./CustomModalTailwind.vue?vue&type=style&index=0&id=c5e2cef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e2cef2",
  null
  
)

export default component.exports